import { Bodytext, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const MainHeading = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
`

export const MainDescription = styled(Bodytext)`
  font-size: 16px;
  line-height: 24px;
  margin: 10px 0px;
`

export const SubHeading = styled(Heading)`
  font-size: 18px;
  line-height: 26px;
  margin: 10px 0px;
`

export const SubDescription = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 30px;
`

export const BreakdownContainer = styled.div`
  display: flex;
  margin: 40px 0px;
  @media screen and (max-width: 630px) {
    flex-direction: column;
  }
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    flex-direction: column;
    margin: 40px 0px;
  }
`

export const SustainableItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;
`

export const SustainableItemDescription = styled(SubDescription)`
  width: 100%;
`

export const Footer = styled(Bodytext)`
  font-size: 12px;
  line-height: 16px;
  color: ${style(theme => theme.colors.stone)};
`

export const StyledImg = styled.img`
  width: 150px;
  height: 96px;
`
